import { render } from "./ThePagination.vue?vue&type=template&id=6cb0effa&scoped=true"
import script from "./ThePagination.vue?vue&type=script&lang=js"
export * from "./ThePagination.vue?vue&type=script&lang=js"

import "./ThePagination.vue?vue&type=style&index=0&id=6cb0effa&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb0effa"]])

export default __exports__